import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { properties } from 'src/environments/properties';

@Component({
    selector: 'app-annual-plan',
    templateUrl: './annual-plan.component.html',
    styleUrls: ['./annual-plan.component.scss']
})
export class AnnualPlanComponent implements OnInit {

    @Input() annualPlan: any;
    @Input() monthlyPlan: any;
    @Input() currentEnvironment;
    @Output() changePlan = new EventEmitter();
    SNAP: string = 'SNAP';
    isSnapVerified: boolean = false;
    annualAutoRenewsPrice: any;
    properties = properties;

    enableForUPlus: boolean = this.properties.featureFlags.enableForUPlus;
    programDisplayData = this.enableForUPlus ? this.properties.programType.forUPlus : this.properties.programType.freshpass;

    ngOnInit(): void {
      this.isSnapVerified = this.monthlyPlan?.promoCategory === this.SNAP ? true : false;
      //condition for autorenews at regualr price
      if (this.annualPlan?.isDiscountedPrice && this.annualPlan?.discountDuration === 1) {
        this.annualAutoRenewsPrice = "$" + this.annualPlan?.regularPlanPrice + this.programDisplayData?.manage?.PLAN_PER_YEAR;
      } else {
        this.annualAutoRenewsPrice = this.annualPlan?.pricingDetailLine1;
      }
    }

    changePlanType(code) {
        this.changePlan.emit(code);
        if (window['AB'] && window['AB']['DATALAYER']) {
            window['AB']['DATALAYER'].analyticsSetLSFPUpdate('changePlanToAnnualBtn');
        }
    };
}
